import loginReducer from 'src/app/redux/reducers/login/loginReducer';
import loginEmailReducer from 'src/app/redux/reducers/login/loginEmailReducer';
import loginPasswordReducer from 'src/app/redux/reducers/login/loginPasswordReducer';


export default {
  loginReducer,
  loginPasswordReducer,
  loginEmailReducer
};
